export default __webpack_public_path__ + "static/media/icon-leader.a83083a9.svg";